module.exports = __webpack_public_path__ + "img/user.37c3ea6b.png";